module Meevo.Plugins.DrawerManager {
    export class MeevoDrawerManagerContent implements angular.IDirective {

        restrict = "A";
        scope = { drawerManager: "=" };
        templateUrl = "app/plugins/drawerManager/directives/drawerManagerContent.template.html";

        link = (scope: any, element: angular.IAugmentedJQuery, attributes: any) => {
            scope.loadContextData = function () {
                scope.section = scope.drawerManager.context.selectedSection;
            }
            scope.showPopDrawerButton = false;

            scope.unWatch = scope.$watchGroup(['drawerManager.context.selectedPrinter', 'drawerManager.context.selectedSection'], (newValues, oldValues, scope) => {
                let printer : Meevo.Model.Device = newValues[0];
                let section: DrawerManagerSectionBase = newValues[1];
                let show: boolean = false;

                if (printer && section && printer && printer.brandId) {
                    switch (section.sectionType) {
                        case DrawerManagerSectionTypeEnum.DrawerOpened:
                        case DrawerManagerSectionTypeEnum.DrawerClosed:
                        case DrawerManagerSectionTypeEnum.OpeningDrawer:
                        case DrawerManagerSectionTypeEnum.CashCalculator:
                        case DrawerManagerSectionTypeEnum.ClosingDrawer:
                        case DrawerManagerSectionTypeEnum.CashTransactions:
                        case DrawerManagerSectionTypeEnum.CreditCardListings:
                        case DrawerManagerSectionTypeEnum.PayIn:
                        case DrawerManagerSectionTypeEnum.PayOut:
                            show = true;
                            break;

                        default:
                            show = false;
                            break;
                    }
                }

                scope.showPopDrawerButton = show;
            });


            // Clean up the watch when this directive is destroyed
            scope.$on('$destroy', function () {
                scope.unWatch();
            });

        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoDrawerManagerContent();
            };
            return directive;
        }

    }

    angular.module("meevo.plugins.drawerManager")
        .directive("meevoDrawerManagerContent", MeevoDrawerManagerContent.factory());
}